import { render } from "./CaptionedImage.vue?vue&type=template&id=51faf058"
import script from "./CaptionedImage.vue?vue&type=script&lang=ts"
export * from "./CaptionedImage.vue?vue&type=script&lang=ts"

import "./CaptionedImage.vue?vue&type=style&index=0&id=51faf058&lang=scss"
script.render = render

export default script